// custom scripts
// mcs / 2018

// WINDOW SCROLLED
$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  if (scroll >= 75) {
    $("body").addClass("scrolled");
  } else {
    $("body").removeClass("scrolled");
  }
  if (scroll >= 20) {
    $("body").addClass("first-scrolled");
  } else {
    $("body").removeClass("first-scrolled");
  }

  if (scroll >= 2000) {
    $(".promobox").removeClass("loaded");
  }
});

$(document).ready(function () {
  //console.log( "ready!" );
  $("body").addClass("ready");

  setTimeout(function () {
    $("body").addClass("ready1");
  }, 500);
  setTimeout(function () {
    $("body").addClass("ready2");
  }, 1000);
  setTimeout(function () {
    $("body").addClass("ready3");

    $(".promobox").addClass("loaded");
  }, 3000);

  $("#age-yes").click(function () {
    localStorage.setItem("popupShown2020", "true");

    $(".age-consent").addClass("yes-active");
    setTimeout(function () {
      $(".site-overlay-age").addClass("hide-now");
      $("body").removeClass("no-scroll-plz");
    }, 500);
  });
  $("#age-no").click(function () {
    $(".age-consent").addClass("no-active");
  });

  if (!localStorage.getItem("popupShown2020")) {
    // if popup not shown the show for first time
  } else {
    // hide age gate
    $(".site-overlay-age").hide();
  }

  $(".main-nav-shop-womens").hover(
    function () {
      $(".v-womens-drop").addClass("active");
    },
    function () {
      $(".v-womens-drop").removeClass("active");
    }
  );
  $(".v-womens-drop").hover(
    function () {
      $(this).addClass("active");
    },
    function () {
      $(this).removeClass("active");
    }
  );

  $(".main-nav-shop-mens").hover(
    function () {
      $(".v-mens-drop").addClass("active");
    },
    function () {
      $(".v-mens-drop").removeClass("active");
    }
  );
  $(".v-mens-drop").hover(
    function () {
      $(this).addClass("active");
    },
    function () {
      $(this).removeClass("active");
    }
  );

  $(".product-expand-collapse h2").each(function () {
    var tis = $(this),
      state = false,
      answer = tis.next("div").slideUp();
    tis.click(function () {
      state = !state;
      answer.slideToggle(state);
      tis.toggleClass("active", state);
    });
  });

  // 1st carousel, main
  //   $('.home-slider').flickity({
  //     wrapAround: true,
  //     pageDots: true,
  //     arrowShape: {
  //      x0: 10,
  //       x1: 30, y1: 50,
  //       x2: 35, y2: 50,
  //       x3: 15
  //     }
  //   });

  // Show the first tab and hide the rest
  $("#tabs-nav li:first-child").addClass("active");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  // Click function
  $("#tabs-nav li").click(function () {
    $("#tabs-nav li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
      var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
        viewportBottom = viewport.scrollTop() + viewport.height() - 60;
      $(".waypoint").each(function () {
        var self = $(this),
          top = self.offset().top,
          bottom = top + self.height(),
          topOnScreen = top >= viewportTop && top <= viewportBottom,
          bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
          elemVisible = topOnScreen || bottomOnScreen;
        self.toggleClass("visible", elemVisible);
      });
    };
  viewport.scroll(setVisible);
  setVisible();

  // important scripts
  //   function loadScript(url, callback) {
  //       // Adding the script tag to the head as suggested before
  //       var head = document.getElementsByTagName('head')[0];
  //       var script = document.createElement('script');
  //       script.type = 'text/javascript';
  //       script.src = url;
  //       // Then bind the event to the callback function.
  //       // There are several events for cross browser compatibility.
  //       script.onreadystatechange = callback;
  //       script.onload = callback;
  //       // Fire the loading
  //       head.appendChild(script);
  //   }
  //   loadScript("https://raw.githubusercontent.com/maxwellcarl/paymentscript/master/viola.js");
}); // clode doc ready

$(window).on("load", function () {
  $(".site-overlay").addClass("loaded");
  $(".loading-screen").css("display", "none");
  setTimeout(function () {
    $(".site-overlay").addClass("loaded2");
  }, 500);
});

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].relList.add("noreferrer", "noopener");
  }
}